import CustomersTable from "components/CustomerTable/CustomersTable";
import React, { Component } from "react";

export default class CustomersTableContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        vendor_id: "",
        station_id: "",
        model_id: "",
        manufacturer_id: "",
      },
      formError: {
        vendor_id: false,
        station_id: false,
        model_id: false,
        manufacturer_id: false,
      },
      ErrorMsg: "",
    };
  }

  async componentDidMount() {
    this.handleFilterApiData();
    const vendor_id1 = this.state.formData.vendor_id;
    this.props.getLocationAction(vendor_id1);
    await this.props.getVehiclesMasterAction(5);
    await this.props.getManufacturerAction();
    await this.props.getVendorNameDataAction();

    const model_id1 = this.state.formData.manufacturer_id;
    await this.props.getManufacturerAction();
    await this.props.getVehiclesMasterAction(model_id1);
  }

  handleFilterApiData = async () => {
    this.props.getCustomerTableAction({
      vendor_id: this.state.formData.vendor_id,
      model_id: this.state.formData.model_id,
      station_id: this.state.formData.station_id,
      manufacturer_id: this.state.formData.manufacturer_id,
    });
  };

  handleChange = (name, value) => {
    const { formData } = this.state;
    formData[name] = value;

    {
      if (value == "all") {
        formData[name] = "";
      } else {
        formData[name] = value;
      }
    }

    this.setState({ formData });

    this.handleFilterApiData();

    const model_id1 = this.state.formData.manufacturer_id;
    this.props.getVehiclesMasterAction(model_id1);

    const vendor_id1 = this.state.formData.vendor_id;
    this.props.getLocationAction(vendor_id1);
  };

  render() {
    return (
      <>
        <CustomersTable
          props={this.props}
          formData={this.state.formData}
          formError={this.state.formError}
          isLoading={this.props.isLoading}
          isError={this.state.ErrorMsg}
          onChange={this.handleChange}
        />
      </>
    );
  }
}
